import { get, post } from "./api";

export const fetchPostCallData = (customerId) => {
  return get(`/api/v2/customers/${customerId}/postcall/`, {}, false, null, true);
};

export const postPostCallData = (customerId, data) => {
    return post(`/api/v2/customers/${customerId}/postcall/`, data);
}